export const GET_NAVIGATION_STATUS = 'GET_NAVIGATION_STATUS'
export const SET_NAVIGATION_STATUS = 'SET_NAVIGATION_STATUS'

export const defaultNavigationState = {
  status: false
}

export default (state = defaultNavigationState, action) => {
  switch (action.type) {
    case SET_NAVIGATION_STATUS:
      return {
        ...state,
        status: action.status
      }
    case GET_NAVIGATION_STATUS:
      return {
        ...state,
      }
    default:
      return state
  }
}
